import React, { useContext, useState } from "react";
import { Route } from "react-router-dom";
import { AuthContext } from "./auth";
import SystemLogin from "../pages/SystemLogin";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { authTokens } = useContext(AuthContext);
  const [showLogin, setShowLogin] = useState(false);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (authTokens && authTokens !== "null") {
          // already logged in  render admin page
          return <Component {...props} />;
        } else {
          // not logged in  show login popup instead
          return (
            <div style={{ position: "relative", height: "100%" }}>
              {/* fallback content: could show "restricted area" message if you want */}
              <div
                style={{
                  display: "flex",
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#666",
                  fontSize: "14px",
                }}
              >
                Administration requires login
              </div>

              {/* login popup overlay */}
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "rgba(0,0,0,0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 999,
                }}
              >
                <div
                  style={{
                    background: "white",
                    borderRadius: "8px",
                    padding: "20px",
                    minWidth: "300px",
                    boxShadow:
                      "0 3px 6px rgba(0,0,0,0.1), 0 3px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <SystemLogin onSuccess={() => setShowLogin(false)} />
                </div>
              </div>
            </div>
          );
        }
      }}
    />
  );
};

export default PrivateRoute;